import { InputGroup, ControlLabel, FormControl } from 'react-bootstrap';
import React from 'react';

const InputWithLabel = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    {label && <ControlLabel>{label}</ControlLabel>}
    <FormControl {...input} type={type} />
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className="alert alert-warning">{warning}</p>))}
  </InputGroup>
);

export default InputWithLabel;



// WEBPACK FOOTER //
// src/forms/InputWithLabel.js